import "core-js";
import "regenerator-runtime/runtime";
import axios from 'axios';
import jQuery from 'jquery';
import gsap from 'gsap';
import CSSPlugin from 'gsap/CSSPlugin'

gsap.registerPlugin(CSSPlugin);
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios = axios;
window.jQuery = window.$ = jQuery;

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}
